import english from './locales/en-US/mobile-shop.json'
import german from './locales/de-DE/mobile-shop.json'
import messageIds from './message-ids.json'
export const sourceMessages: Record<string, string> = Object.fromEntries(Object.entries(messageIds).map(([legacy, id]) => [legacy, english[id as keyof typeof english]]))
const ids: Record<string, string> = messageIds
const en: Record<string, string> = english
const de: Record<string, string> = german
export type Translate = (key: string, values?: Record<string, string | number>) => string
export interface LocalizationBundle { locale: string; messages: Record<string, string>; supportedLocales?: string[] }
export function normalizeLocale(value?: string): string {
    try { return Intl.getCanonicalLocales((value || 'en-GB').replace(/_/g, '-'))[0] || 'en-GB' } catch { return 'en-GB' }
}
export function makeTranslator(locale: string, messages: Record<string, string> = {}): Translate {
    return (key, values = {}) => {
        const id = ids[key] || key
        const fallback = (normalizeLocale(locale).startsWith('de') ? de[id] : en[id]) || key
        const translated = messages[id] || messages[key]
        const message = typeof translated === 'string' && translated ? translated : fallback
        return message.replace(/\{\{\s*(\w+)\s*\}\}/g, (original, name: string) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : original)
    }
}
export function parseBundle(value: unknown): LocalizationBundle | undefined {
    if (!value || typeof value !== 'object') return
    const raw = value as Record<string, unknown>
    if (typeof raw.locale !== 'string' || !raw.messages || typeof raw.messages !== 'object' || Array.isArray(raw.messages)) return
    return { locale: normalizeLocale(raw.locale), messages: Object.fromEntries(Object.entries(raw.messages).filter(([key, value]) => Object.prototype.hasOwnProperty.call(sourceMessages, key) && typeof value === 'string')) as Record<string, string>, supportedLocales: Array.isArray(raw.supportedLocales) ? raw.supportedLocales.filter((value): value is string => typeof value === 'string') : undefined }
}
